import { SensorData } from 'Simulations/SensorPoint';
import { StageParameters, TransformStage } from '../../Stage';

export interface InvertStageParams extends StageParameters {}

class InvertStage extends TransformStage<InvertStageParams> {
    constructor() {
        super({});
    }

    override process(input: SensorData): SensorData {
        const direction = input.getVectorialResult();
        input.setVectorialValue(direction.mult(-1));

        return input;
    }
}

export default InvertStage;
